import { CostCodeType } from '../models/Project';
export class CostCodeUtils {
    /** "01 - General Conditions" -> "01" */
    static getDivisionNumber(divisionName) {
        return divisionName?.split(' - ')[0]?.trim() ?? '';
    }
    /** "01 - General Conditions" -> "General Conditions" */
    static getDivisionLabel(divisionName) {
        const idx = divisionName?.indexOf(' - ') ?? -1;
        return idx >= 0 ? divisionName.slice(idx + 3).trim() : (divisionName ?? '').trim();
    }
    static formatDivisionName(divisionNumber, name) {
        return `${divisionNumber} - ${name}`;
    }
    static groupCostCodesByDivision(docs) {
        const groups = {};
        const getGroup = (divisionId) => groups[divisionId] ?? (groups[divisionId] = { division_id: divisionId, division_name: '', codes: [] });
        for (const doc of docs) {
            if (doc.type === CostCodeType.DIVISION) {
                getGroup(doc._id).division_name = CostCodeUtils.formatDivisionName(doc.division, doc.name);
            }
            else {
                getGroup(doc.division_id).codes.push(doc);
            }
        }
        return groups;
    }
    static findCostCodeAndDivisionByCodeNumber(codes, codeNumber) {
        const foundCode = codes.find((code) => code.type === CostCodeType.COST_CODE && code.code === codeNumber);
        if (!foundCode) {
            return null;
        }
        const division = codes.find((code) => code.type === CostCodeType.DIVISION && code._id === foundCode.division_id);
        return { code: foundCode, division };
    }
}
